import { cx } from '@emotion/css';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { Button } from 'apps/shared/scripts/components';
import { useCardDesigns } from 'apps/shared/scripts/graphql';

import CardPreviewDesign from './CardPreviewDesign';
import { DEFAULT_DESIGN } from './constants';
import {
  actionClassName,
  buttonClassName,
  buttonIconClassName,
  buttonTextClassName,
  cardContainerClassName,
  cardPreviewCardClassName,
  desktopActionClassName,
  desktopCardContainerClassName,
  desktopCardPreviewCardClassName,
  desktopFooterClassName,
  desktopHeaderClassName,
  desktopMessageClassName,
  desktopWrapperClassName,
  dividerClassName,
  footerClassName,
  footingClassName,
  headerClassName,
  headingClassName,
  heroClassName,
  messageClassName,
  prefixClassName,
  signatureClassName,
  subheadingClassName,
  suffixClassName,
  textClassName,
  wrapperClassName,
} from './styles';

interface Props {
  designId: string;
  headline: string;
  recipientName: string;
  senderName?: string;
  desktop?: boolean;
}

const CardPreviewCard = ({
  designId,
  headline,
  recipientName,
  senderName,
  desktop,
}: Props) => {
  const { designs } = useCardDesigns();

  const design = designs.find((d) => d.id === designId);

  return (
    <CardPreviewDesign design={design ?? DEFAULT_DESIGN}>
      <div
        className={cx(cardPreviewCardClassName, {
          [desktopCardPreviewCardClassName]: desktop,
        })}
      >
        <div
          className={cx(cardContainerClassName, {
            [desktopCardContainerClassName]: desktop,
          })}
        >
          <div
            className={heroClassName}
          >
            <div
              className={cx(wrapperClassName, {
                [desktopWrapperClassName]: desktop,
              })}
            >
              <div
                className={cx(headerClassName, {
                  [desktopHeaderClassName]: desktop,
                })}
              >
                <h4 className={subheadingClassName}>
                  {recipientName || 'Recipient Name'},
                </h4>
                <h2 className={headingClassName}>{headline || 'Headline'}</h2>
              </div>
              <div
                className={cx(actionClassName, {
                  [desktopActionClassName]: desktop,
                })}
              >
                <Button
                  className={buttonClassName}
                  faIcon={faPlus}
                  iconClassName={buttonIconClassName}
                  onClick={(e) => e?.preventDefault()}
                  textClassName={buttonTextClassName}
                >
                  Add a Post
                </Button>
              </div>
            </div>
            {senderName && (
              <div
                className={cx(footerClassName, {
                  [desktopFooterClassName]: desktop,
                })}
              >
                <h6 className={footingClassName}>
                  <span className={prefixClassName}>From</span>
                  <span className={suffixClassName}>{senderName}</span>
                </h6>
              </div>
            )}
          </div>
          <div
            className={cx(messageClassName, {
              [desktopMessageClassName]: desktop,
            })}
          >
            <div className={textClassName} />
            <div className={dividerClassName} />
            <div className={textClassName} />
            <div className={dividerClassName} />
            <div className={signatureClassName} />
          </div>
        </div>
      </div>
    </CardPreviewDesign>
  );
};

CardPreviewCard.displayName = 'CardPreviewCard';

export default CardPreviewCard;
